<template>
  <div id="section9">
    <div class="fondoGrisClaro" >
      <b-container fluid>
        <b-container>
          <br />
          <b-row align-v="center">
            <b-col md="4" sm="12" class="text-center">
              <b-img :src="payImg"/>
            </b-col>
            <b-col md="8" sm="12">
              <br>
              <h2>
                {{$t("payTitulo")}}
              </h2>
              <h3>
                {{$t("payTtl")}}
              </h3>
              <p >
                {{$t("payText")}}
              </p>
              <div>
                <a :href="payUrl" class="btn buttonTurqueza">
                  {{$t("payBtn")}}
                </a>
              </div>
              <br />
            </b-col>
          </b-row>
          <br />
        </b-container>
      </b-container>
    </div>
  </div>
</template>

<i18n>
{
  "en":{
    "payTitulo": "Imsolutions"
    , "payTtl": "Empresa tecnológica que facilita soluciones de pago amigables, seguras y omnicanal basadas en tecnología innovadora y flexible. Realizan la integración de soluciones de pago presenciales y OnLine. IMSolutions es una compañía Liberto Group."
    , "payText": " "
    , "payBtn": "MÁS INFORMACIÓN"
  },
  "es":{
    "payTitulo": "Imsolutions"
    , "payTtl": "Empresa tecnológica que facilita soluciones de pago amigables, seguras y omnicanal basadas en tecnología innovadora y flexible. Realizan la integración de soluciones de pago presenciales y OnLine. IMSolutions es una compañía Liberto Group."
    , "payText": " "
    , "payBtn": "MÁS INFORMACIÓN"
  }
}
</i18n>

<script>
export default {
  data() {
    return {
      payImg: require("@/assets/images/pay/partners/imsolutions.png")
      , payUrl: "#"
    };
  }
};
</script>
